
module.exports = {

	dayNames: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
	dayNamesShort: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	monthNames: ['January', 'February', 'March', 'April', 'May','June', 'July', 'August', 'September', 'October', 'November', 'December'],
	monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],

	"date_to": "-",

	/* PeopleSelect */
	"Anzahl Kinder": "Children",
	"Anzahl Erwachsene": "Adults",
	"Personen": "People",
	"Anzahl Zimmer": "Rooms",

	"Zeitraum wählen": "Select date",
	"Alter bei Reiseantritt": "Age on travel begin",
	"Jahre": "years",
	"Kind": "child",
	"Kein Zeitraum": "No date selected",

	/* PeopleDisplay */
	"adult": "adult",
	"adult_plural": "adults",

	"people": "people",
	"people_plural": "people",

	"child": "child",
	"child_plural": "children",

	"1 Nacht": "one night",
	"Nächte": "nights",

	"anfragen_btn": "inquiry",
	"bucken_btn": "booking",

	/* DesktopApp */
	"search_btn": "Search",
	"calendar_hint": "Click first on the arrival date, then the departure.",

}




/** WEBPACK FOOTER **
 ** ../ibe/translation/en.js
 **/